import * as Scrivito from "scrivito";
import I18n from "^/config/i18n";
import ImageOrVideo from "../../Components/ImageOrVideo";

export const NewsWidgetComponent = Scrivito.connect(({ widget }) => {
  const obj = widget.get("destination");
  if (!obj) {
    return (
      <div className="alert alert-warning">
        {I18n.t("no_news_selected", { ns: "live" })}
      </div>
    );
  }

  return (
    <Scrivito.WidgetTag className="teaser-box --event">
      <Scrivito.LinkTag
        to={obj}
        className="teaser-box__wrapper d-block bg-white"
      >
        <ImageOrVideo
          widget={obj}
          teaser={true}
          className="teaser-box__image"
        />
        <div className="teaser-box-content">
          <Scrivito.ContentTag
            content={obj}
            attribute="title"
            tag="h4"
            className="teaser-box__title"
          />
          <Scrivito.ContentTag
            content={obj}
            attribute="shortDescription"
            tag="div"
            className="teaser-box__description"
          />
          <span className="teaser-box__button">
            <i className="las la-angle-right me-2"></i>
            {I18n.t("news to news")}
          </span>
        </div>
      </Scrivito.LinkTag>
    </Scrivito.WidgetTag>
  );
});

Scrivito.provideComponent("NewsWidget", NewsWidgetComponent);
